




import Vue from 'vue';
import { SchemaModel } from '@/types';
import DynamicForm from '@/components/shared/DynamicForm.vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'DefaultBuiltInListItem',
  components: { DynamicForm },
  props: {
    schemas: {
      type: Array as () => SchemaModel[],
      required: true
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    onDirtyDynamicForm(this: any, dirty: boolean) {
      if (dirty) {
        this.setApplicationDirty(true);
      }
    }
  },
  computed: {
    schema: {
      get(this: any) {
        return this.schemas;
      },
      async set(this: any, value: SchemaModel[]) {
        this.$emit('update:schema', value);
      }
    }
  }
});
